import React from "react";
import PropTypes from "prop-types";
import Commission from "../../components/Commission";

const CommissionPage = (props) => {
  return <Commission />;
};

CommissionPage.propTypes = {};

export default CommissionPage;
